<template>
    <div class="content-div">
        <div class="form-box">
            <el-form :rules="rules" ref="ruleForm" :model="drawerForm" label-width="150px">
                <div class="top-title">基础信息</div>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="指令名称 : " prop="instrustName">
                            <el-input class="inputClass" v-model="drawerForm.instrustName" placeholder="请输入" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="通道" prop="canChannel">
                            <el-select size="mini"
                                       style="width: 320px"
                                       v-model="drawerForm.canChannel"
                                       placeholder="请选择通道"
                                       :popper-append-to-body='false' popper-class='select-popper'>
                                <el-option
                                        v-for="(item,index) in 2"
                                        :key="index"
                                        :label="`通道${index}`"
                                        :value="index">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="地址类型" prop="addressType">
                            <el-select style="width: 320px" size="mini"
                                       v-model="drawerForm.addressType" placeholder="请选择地址类型"
                                       :popper-append-to-body='false' popper-class='select-popper'>
                                <el-option label="物理地址" value="0"></el-option>
                                <el-option label="功能地址" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="帧类型 : " prop="frameType">
                            <el-select class="inputClass" v-model="drawerForm.frameType" placeholder="请选择帧类型">
                                <el-option label="标准帧" :value="0"></el-option>
                                <el-option label="拓展帧" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="请求地址(0X) : " prop="frameId">
                            <el-input class="inputClass" v-model="drawerForm.frameId" placeholder="请输入" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="响应地址(0X) : " v-if="drawerForm.addressType === '0' || drawerForm.addressType === undefined" prop="receiveAddress">
                            <el-input class="inputClass" v-model="drawerForm.receiveAddress" placeholder="请输入" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="响应地址(0X) : " v-else>
                            <el-input class="inputClass" v-model="drawerForm.receiveAddress" placeholder="请输入" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="长度 : " prop="instructLength">
<!--                            <el-input class="inputClass" :disabled="dialogType === 2" v-model="drawerForm.instructLength" placeholder="请输入" size="small"></el-input>-->
                            <el-select class="inputClass" v-model="drawerForm.instructLength" placeholder="请选择">
                                <el-option
                                        v-for="item in options"
                                        :key="item.id"
                                        :label="item.dictName"
                                        :value="item.dictValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="数据 : " prop="instructContent">
                            <el-input class="inputClass" v-model="drawerForm.instructContent" placeholder="请输入" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="所属车型 : " prop="vehicleType">
                            <el-select class="inputClass" v-model="drawerForm.vehicleType" placeholder="请选择" size="small">
                                <el-option
                                        v-for="item in carOptions"
                                        :key="item.vehicleTypeCode"
                                        :label="item.vehicleTypeName"
                                        :value="item.vehicleTypeCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="指令描述 : ">
                            <el-input class="inputClass" type="textarea" :rows="6" placeholder="请输入内容" v-model="drawerForm.instrustDesc"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="bottom-btn">
            <el-button @click="submitData(1)" :loading="submitType" type="primary" size="mini">确定</el-button>
            <el-button @click="submitData(2)" size="mini">取消</el-button>
        </div>
    </div>
</template>

<script>
    import {addDatavehicle,getDictList,updateDataInstruct} from "../../../common/command";
    import {getDatavehicleTypeList} from "../../../common/carModelApi";

    export default {
        name: "commandDialog",
        props: {
            drawerForm: {
                type: Object,
                // frameType: {
                //     type: Number,
                //     default: 0
                // },
            },
            dialogType: {
                type: Number
            }
        },
        data() {
            let frameId = (rule, value, callback) => {
                console.log(value)
                // console.log(this.hex2Number(value));
                // console.log(this.drawerForm.frameId)
                let aa = this.hex2Number('0x0')
                let bb = this.hex2Number('0x7ff')
                let val = this.hex2Number(value)
                // console.log(aa,bb,val)
                if ( value.indexOf('0x') !== 0 ) {
                    callback(new Error("请输入以0x开头的请求地址"));
                }
                if(val < aa  ||  val>bb){
                    callback(new Error("请在0x0到0x7ff范围之内输入请求地址"));
                }
            };
            let frameId2 = (rule, value, callback) => {
                console.log(this.hex2Number('0x11'));
                console.log(value)
                this.drawerForm.frameId = value
                // console.log(this.drawerForm.frameId)
                let aa = this.hex2Number('0x0')
                let bb = this.hex2Number('0x1FFFFFFF')
                let val = this.hex2Number(value)
                console.log(aa,bb,val)
                if ( value.indexOf('0x') !== 0 ) {
                    callback(new Error("请输入以0x开头的请求地址"));
                }
                if(val <= aa || val > bb){
                    callback(new Error("请在0x0到0x1FFFFFFF范围之内输入请求地址"));
                }
            };
            let receiveAddress = (rule, value, callback) => {
                console.log(value)
                let aa = this.hex2Number('0x0')
                let bb = this.hex2Number('0x7ff')
                let val = this.hex2Number(value)
                // console.log(aa,bb,val)
                if ( value.indexOf('0x') !== 0 ) {
                    callback(new Error("请输入以0x开头的响应地址"));
                }
                if(val < aa  ||  val>bb){
                    callback(new Error("请在0x0到0x7ff范围之内输入响应地址"));
                }
            };
            let receiveAddress2 = (rule, value, callback) => {
                console.log(this.hex2Number('0x11'));
                console.log(value)
                this.drawerForm.receiveAddress = value
                // console.log(this.drawerForm.frameId)
                let aa = this.hex2Number('0x0')
                let bb = this.hex2Number('0x1FFFFFFF')
                let val = this.hex2Number(value)
                console.log(aa,bb,val)
                if ( value.indexOf('0x') !== 0 ) {
                    callback(new Error("请输入以0x开头的响应地址"));
                }
                if(val <= aa || val > bb){
                    callback(new Error("请在0x0到0x1FFFFFFF范围之内输入响应地址"));
                }
            };
            return {
                rules: {
                    addressType: [
                        {required: true, message: '请选择地址类型', trigger: 'change'}
                    ],
                    instrustName: [
                        {required: true, message: '请输入指令名称', trigger: 'blur'},
                    ],
                    frameId: [
                        {required: true, message: '请输入帧ID', trigger: 'blur'},
                        // { validator: frameId, trigger: 'blur' }
                    ],
                    receiveAddress: [
                        {required: true, message: '请输入响应地址', trigger: 'blur'},
                        // { validator: receiveAddress, trigger: 'blur'},
                    ],
                    instructLength: [
                        {required: true, message: '请输入长度', trigger: 'blur'},
                    ],
                    instructContent: [
                        {required: true, message: '请输入数据', trigger: 'blur'},
                    ],
                    vehicleType: [
                        {required: true, message: '请选择所属车型', trigger: 'change'}
                    ],
                    frameType: [
                        {required: true, message: '请选择帧类型', trigger: 'change'}
                    ],
                    canChannel: [
                        {required: true, message: '请选择通道', trigger: 'change'}
                    ],
                },
                submitType: false,
                carOptions: [],
                options: []
            }
        },
        mounted() {
            this.getDatavehicleTypeList()
            this.initLength()

            console.log(this.drawerForm.frameType)
        },
        methods: {
            hex2Number(str) {
                if (str.indexOf('0x') === 0) {
                    str = str.slice(2);
                }
                return parseInt(`0x${str}`, 16);
            },
            async initLength() {
                const res = await getDictList({pageNo:0,pageSize:0,dictCode:'instruct_length'})
                console.log(res)
                this.options = res.data
            },
            async querySearch(queryString, cb) {
                const res = await getDataTboxListNoUse({imei: queryString})
                if (res.code === 200) {
                    // // 调用 callback 返回建议列表的数据
                    cb(res.data);
                } else {
                    this.$notify.error({
                        title: '错误提示',
                        message: res.msg
                    })
                }
            },

            // 数据提交
            async submitData(type) {

                // if (this.drawerForm.frameId) {
                //     this.drawerForm.frameId = this.drawerForm.frameId
                // } else {
                //     this.drawerForm.frameId2 = this.drawerForm.frameId
                // }
                // console.log(this.drawerForm.frameId)
                /*
                  * dialogType
                  * 1   新增
                  * 2   修改
                  * */
                if (type === 1) {
                    this.$refs.ruleForm.validate(async (valid) => {
                        if (valid) {
                            let str = ''
                            this.carOptions.find(item => {
                                if (item.vehicleTypeCode === this.drawerForm.vehicleType) {
                                    str = item.vehicleTypeName
                                }
                            })
                            this.drawerForm.vehicleTypeName = str
                            this.drawerForm.addressType = this.drawerForm.addressType*1
                            this.submitType = true
                            if (this.dialogType === 1) {
                                try {
                                    const res = await addDatavehicle(this.drawerForm)
                                    if (res.code === 200) {
                                        this.$notify.success({
                                            title: '成功提示',
                                            message: '指令新增成功'
                                        })
                                        this.submitType = false
                                        this.$emit('drawerClose')
                                    } else {
                                        this.$notify.error({
                                            title: '错误提示',
                                            message: res.msg
                                        })
                                        this.submitType = false
                                    }
                                } catch (e) {
                                    this.submitType = false
                                    console.log(e)
                                }
                            } else {
                                try {
                                    const res = await updateDataInstruct(this.drawerForm)
                                    if (res.code === 200) {
                                        this.$notify.success({
                                            title: '成功提示',
                                            message: '试指令修改成功'
                                        })
                                        this.submitType = false
                                        this.$emit('drawerClose')
                                    } else {
                                        this.$notify.error({
                                            title: '错误提示',
                                            message: res.msg
                                        })
                                        this.submitType = false
                                    }
                                } catch (e) {
                                    this.submitType = false
                                    console.log(e)
                                }
                            }
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                } else {
                    this.$emit('drawerClose')
                }
            },
            // 获取车型列表
            async getDatavehicleTypeList() {
                try {
                    const res = await getDatavehicleTypeList()
                    if (res.code === 200) {
                        this.carOptions = res.data
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg
                        });
                    }
                } catch (e) {
                    console.log(e)
                }
            },
        }
    }
</script>


<style scoped>
    .content-div /deep/ .el-form-item__error {
        padding-top: 0 !important;
    }

    .form-box {
        box-sizing: border-box;
        padding: 0 60px 0 20px;
    }

    .form-box /deep/ .el-form-item {
        margin-bottom: 10px !important;
    }

    .top-title {
        text-align: left;
        margin-bottom: 20px;
        margin-top: 20px;
        font-size: 18px;
        font-weight: 700;
    }

    .bottom-btn {
        position: absolute;
        bottom: 20px;
        right: 20px;
    }
    .inputClass{
        width:320px;
    }
</style>
